import {NotificationService} from "../../services/NotificationService";
import {ApplicationSettingService} from "../../services/ApplicationSettingService";
import {ReaderService} from "../../services/ReaderService";
import {Reader} from "../../entities/Reader";
import {PagingModel} from "../paging/PagingModel";

export class CmdCenterSetPositionGatewayModel extends PagingModel<Reader> {
    static $inject = ['$q', 'ReaderService', 'ApplicationSettingService', 'NotificationService'];
    selectedGateway: Reader;
    gatewayName: string = "";
    errorMessage: string = "";
    feetPerMeter: number = 3.28084;
    x: number;
    y: number;
    z: number;
    measureType: string;
    useMeters: boolean;

    constructor($q: ng.IQService,
                public pagingService: ReaderService,
                public applicationSettingService: ApplicationSettingService,
                public notifyService: NotificationService) {
        super($q, pagingService, notifyService);
    }

    init(x: number, y: number, z: number) {
        this.applicationSettingService.getCached().then((data) => {
            this.useMeters = data.useMeters;
            if (!this.useMeters) {
                this.x = x * this.feetPerMeter;
                this.y = y * this.feetPerMeter;
            } else {
                this.x = x;
                this.y = y;
            }
            this.z = z;
            this.measureType = this.useMeters ? "meters" : "feet";
        });
    }

    entityName(): string {
        return "reader";
    }

    displayName(): string {
        return "Gateways";
    }

    getColumnDefs(): ng.IPromise<void> {
        this.nameValuePairs =
            [
                ['name', 'Name', 150],
                ['readerModel', 'Reader Model', 200]
            ];
        return this.$q.when();
    }

    selectionChanged(): void {
        if (this.selectedItems.length > 0) {
            this.selectedGateway = this.selectedItems[0];
            this.gatewayName = this.selectedItems[0].name;
        } else {
            this.selectedGateway = null;
            this.gatewayName = "";
        }
    }
}
